"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var useStyles_1 = __importDefault(require("./useStyles"));
/**
* Section for a Card Component.
*/


var CardSection = function CardSection(_a) {
  var children = _a.children,
      style = _a.style;
  var classes = (0, useStyles_1.default)();
  return react_1.default.createElement("div", {
    className: classes.section + " story-card__section",
    style: style
  }, react_1.default.createElement(Typography_1.default, {
    variant: "caption"
  }, children));
};

CardSection.propTypes = {
  /** Styling object of the `Card` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object
};
CardSection.defaultProps = {
  style: undefined
};
exports.default = CardSection;